import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../shared/services/user.service';



export interface CanComponentLeave{
  canLeave: () => boolean;
}

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate, CanDeactivate<CanComponentLeave>{

  constructor(private router : Router, private service :UserService){
    
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    //state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    state: RouterStateSnapshot): boolean {
      if(localStorage.getItem("token") != null)
      {
        let roles = next.data["permittedRoles"] as Array<string>;
        if(roles)
        {
          if(this.service.roleMatch(roles))
          {
             return true;
          }
          else
          {  
            this.router.navigate(['/forbidden']);
            return false;
          }
        }
        return true;
      }
      else{
        this.router.navigate(['/login']);
        return false;
      }
  }

  canDeactivate(compoment : CanComponentLeave){
    if(compoment.canLeave){
      return compoment.canLeave();
    }

    return true;
  }
  
}
